import { Clients } from '@xiag-search/sdk';
import { RecommendationEventData } from '@xiag-search/sdk/dist/types/src/interfaces';

export async function sendVisitRecommendationEvent(
    global: Window,
    engineId: string,
    clients: Promise<Clients>,
): Promise<void> {
    const clientsResolved = await clients;
    const href = global.location.href.toString();
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    const targetEntityId = canonicalLink
        ? canonicalLink.getAttribute('href') || href
        : href;
    const event: RecommendationEventData = {
        engineId,
        data: {
            targetEntityId,
            event: 'visit',
        }
    };
    clientsResolved.eventsClient.sendRecommendationEvent([event]);
}
